<template>
  <div class="logo-and-editor-container fly-in-3">
    <div class="hint-wrapper">
      <div class="hint" @click="toggle()"><img width="6px" src="images/info.svg" alt="infomation"></div>
    </div>
    <div
      :class="{
        'logo-and-editor-wrapper': true,
        'enter-in': enterFlag,
        'leave-out': !enterFlag,
      }"
    >
      <div class="toggle-button-wrapper" @click="toggle()">
        <i class="up"></i>
      </div>
      <div class="title-wrapper">
        寫一封信給 921
      </div>
      <div class="editor-wrapper">
        <div class="title">
          <div>統籌製作</div>
          <div>影像</div>
          <div>設計</div>
          <div>網頁製作</div>
          <div>數位行銷</div>
          <div>&nbsp</div>
          <div>製作單位</div>
          <div>&nbsp</div>
          <div>監製</div>
        </div>
        <div class="name">
          <div>謝汶均</div>
          <div>陳正興</div>
          <div>蘇士堯</div>
          <div>楊若榆</div>
          <div>陳雨暄</div>
          <div>劉時均</div>
          <div>聯合報新媒體中心</div>
          <div>視覺設計中心</div>
          <div>聯合報新聞部</div>
        </div>
      </div>
      <div class="logo-wrapper">
        <div class="logo">
          <a href="https://udn.com/news/index" target="_blank">
            <img src="images/logo/udndotcom_logo.svg" alt="聯合新聞網">
          </a>
        </div>
        <div class="logo"><img src="images/logo/nm_logo.svg" alt="聯合報新媒體中心"></div>
      </div>
      <div class="time">
        2019.09.02
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoAndEditorMob',
  data() {
    return {
      enterFlag: false,
    };
  },
  methods: {
    toggle() {
      this.enterFlag = !this.enterFlag;
    },
  }
};
</script>

<style lang="scss" scoped>
  .logo-and-editor-container {
    background-color: #f1f1f1;
    color: #a5a5a5;
  }

  .hint-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1%;
    .hint {
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px;
      border-radius: 50%;
      cursor: pointer;
    }
  }

  .enter-in {
    opacity: 1;
    transform: translateY(0);
  }

  .leave-out {
    opacity: 0;
    transform: translateY(100%);
  }

  .logo-and-editor-wrapper {
    position: fixed;
    bottom: 0;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f1f1f1;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
    padding: 3% 0 10% 0;
    transition: .333s ease-in-out;
    
    .toggle-button-wrapper {
      padding: 3%;
      cursor: pointer;
      animation: bounce 2s infinite linear;
      i {
        border: solid #57b09f;
        border-width: 0 5px 5px 0;
        display: inline-block;
        padding: 7px;
      }
      .up {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }

      @keyframes bounce {
        0% {transform: translateY(-3px);}
        50% {transform: translateY(3px);}
        100% {transform: translateY(-3px);}
      }
    }

    .title-wrapper {
      padding: 5% 5% 0 5%;
      font-size: 20px;
      font-weight: bold;
      @media only screen and (max-width: 320px) {
        font-size: 16px;
      }
    }

    .editor-wrapper {
      position: relative;
      display: flex;
      @media only screen and (max-width: 320px) {
        font-size: 12px;
      }
      .title {
        padding: 15px;
        text-align: right;
      }
      .name {
        padding: 15px;
        text-align: left;
      }
    }

    .logo-wrapper {
      width: 100%;
      text-align: center;
      .logo {
        display: inline-block;
        margin: 10px 20px;
        text-align: center;
        a {
          width: 100%;
          text-align: center;
        }
        img {
          width: 30vw;
        }
      }
    }
    .time {
      @media only screen and (max-width: 320px) {
        font-size: 12px;
      }
    }
  }
</style>
